// extracted by mini-css-extract-plugin
export var boardSection = "BoardOfDirectors-module--boardSection--UrXKK";
export var sectionTitle = "BoardOfDirectors-module--sectionTitle---FOs4";
export var teamGrid = "BoardOfDirectors-module--teamGrid--4Dczc";